import type { FormFieldWarningDTO, FormItemResponseDTO } from '@/api/base/DTOs';
import type { FormFieldWarning } from '@/forms/typings';

/** Maps warning DTOs onto the field model; undefined when there are none. */
export const adaptFormFieldWarnings = (
  warnings?: FormFieldWarningDTO[],
): FormFieldWarning[] | undefined => {
  if (!warnings?.length) return undefined;

  return warnings.map(warning => ({
    maxValue: warning.maxValue,
    title: warning.title,
    description: warning.description,
  }));
};

/**
 * Pulls warnings off a field's restriction. Narrows internally because
 * `restriction` lives on the field DTO, not on the shared item base.
 */
export const adaptFormFieldWarningsResponse = (
  item: FormItemResponseDTO,
): FormFieldWarning[] | undefined => {
  if (!('restriction' in item) || !item.restriction) return undefined;
  // Other item types carry a restriction shape of their own (e.g. fields-group,
  // file) that never has warnings. A date range's `toWarnings` belong to its
  // "to" date, so the range adapter attaches those.
  if (!('warnings' in item.restriction)) return undefined;

  return adaptFormFieldWarnings(item.restriction.warnings);
};
